import $ from 'jquery';
if ($("#jv_recruiting_video_page").length) {
        document.getElementById("myVideo").onended = function() { myFunction() };

    function myFunction() {
        var total = $("#totalVideoCount").val();
        var index = $("#currentVideo").val();
        var cat = $("#category").val();
        index = parseInt(index) + 1;
        if (index == parseInt(total)) {
            index = 0;
        }
        var name = "#vt_" + index;
        var nextTitle = $(name).val();
        nextTitle = nextTitle.replace("?", "%3F");
        window.location.href = '/recruiting/'+cat+'/'+nextTitle+'';
    }
}

if ($("#recruiting_vip_video_page").length) {
    document.getElementById("myVideo").onended = function () { myFunction() };

    function myFunction() {
        var total = $("#totalVideoCount").val();
        var index = $("#currentVideo").val();
        var cat = $("#category").val();
        index = parseInt(index) + 1;
        if (index == parseInt(total)) {
            index = 0;
        }
        var name = "#vt_" + index;
        var nextTitle = $(name).val();
        nextTitle = nextTitle.replace("?", "%3F");
        window.location.href = '/recruiting/' + cat + '/' + nextTitle + '';
    }
}

if ($("#jv_recruiting_home_page").length) {
    $('#scroll_down').on('click', (e) => {
        $("html, body").stop().animate({ scrollTop: e.currentTarget.offsetTop }, 500, 'swing')
    });

    $('.video-details').on('click', '.close-btn', function (e) {
        $('.video-details').removeClass('show');
    });

    $(document).on('keydown', function (ev) {
        if (event.key == "Escape") {
            $('.video-details').removeClass('show');
        }
    });

    $('#champs_carousel_web .carousel-item').each(function () {
        if ($(window).width() > 1200) {
        var next = $(this).next();
        if (!next.length) {
            next = $(this).siblings(':first');
            }
        next.children(':first-child').clone().appendTo($(this));
        }
    });
}